import gql from "graphql-tag";

export const ORDER_PDF = gql`
  query orderPdf($id: ID!) {
    order(id: $id) { id pdf: orderPdf { id url } }
  }
`;
